import { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Button,
  MenuItem,
  Select,
  FormControl,
  Snackbar,
  Alert,
  InputLabel,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import styles from "./Account.module.css"; // Custom CSS for additional styling
import CustomInput from "../../../shared/utils/Input";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import CustomButton from "../../../shared/utils/Button";
import axios from "axios";
import { verifyGST } from "../../../shared/utils/gstInfoApi";
import { Cross, VerifiedTick } from "../../../shared/assets/icons";
import { statecityData } from "../../../shared/enums";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar";
import CircularProgress from "@mui/material/CircularProgress";
import capitalizeWords from "../../../helperFunctions/capitalizedWords";

const serverURL = process.env.REACT_APP_URL;

const Organisation = () => {
  const userRole = localStorage.getItem("userRole");
  const [isEditable, setIsEditable] = useState(false); // State to track edit mode
  const [isClientId, setIsclientId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const getOrganizationDetails = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/client/organizationDetails/${id}`,

        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setFormData(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const [isGstVerfied, setIsGstVerified] = useState(false);
  const [cityArray, setCityArray] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [formData, setFormData] = useState({
    name: "",
    gstin: "",
    sector: "",
    organizationSize: "",
    organizationAddress: "",
    city: "",
    state: "",
    zipCode: "",
  });

  const clientId = localStorage.getItem("clientId");
  useEffect(() => {
    setIsclientId(clientId);
    getOrganizationDetails(clientId);
  }, []);
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;

  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === formData.state,
    )?.iso2;

    if (formData.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);

          // Log the city names
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      // Example usage: Fetch cities in Maharashtra (state code "MH")
      fetchCities(stateCode);
    }
  }, [formData.state]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // loading state for API calls

  const handleInputChange = async (e) => {
    const { name, value, files } = e.target;
    setErrors({ ...errors, gstin: "" });
    setIsGstVerified(false);
    if (files?.length > 0) {
      let file = files[0];
      const formDataNew = new FormData();
      formDataNew.append("files", file);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.success) {
          setFormData({
            ...formData,
            brandLogo: response?.data?.data[0], // Store the image as a Data URL for preview
            // binaryImage: file, // Store the original binary file
          });
        }
      } catch (err) {
        console.error("Error uploading file", err);
      }
    } else {
      if (name == "state") {
        formData.city = "";
      }
      // Handle text input logic
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value, // Update only the input field that has changed
      }));
      // Validate the input and remove the error if it's valid
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };

        // Gst validation
        if (name === "gstin" && value.length === 15) {
          fetchDetailsThroughGSTIN(value);
        }

        // Organization validation
        if (name === "organizationSize" && value) {
          delete newErrors.organizationSize;
        }

        // Sector validation
        if (name === "sector" && value) {
          delete newErrors.sector;
        }

        return newErrors;
      });
    }
  };
  const fetchDetailsThroughGSTIN = async (gstNumber) => {
    setLoading(true);
    const responseData = await verifyGST(gstNumber);
    setLoading(false);

    if (responseData.error) {
      setErrors({ ...errors, gstin: "Enter valid GSTIN" });
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData, // Keep previous form data, including `gstin`
        gstin: gstNumber, // Ensure `gstin` remains intact
        state: responseData?.taxpayerInfo?.pradr?.addr?.stcd || "",
        city: responseData?.taxpayerInfo?.pradr?.addr?.dst || "",
        name: capitalizeWords(responseData?.taxpayerInfo?.tradeNam) || "",
        zipCode: responseData?.taxpayerInfo?.pradr?.addr?.pncd || "",
        organizationAddress: capitalizeWords(
          [
            responseData?.taxpayerInfo?.pradr?.addr?.flno,
            responseData?.taxpayerInfo?.pradr?.addr?.bno,
            responseData?.taxpayerInfo?.pradr?.addr?.st,
            responseData?.taxpayerInfo?.pradr?.addr?.landMark,
            responseData?.taxpayerInfo?.pradr?.addr?.locality,
            responseData?.taxpayerInfo?.pradr?.addr?.loc,
          ]
            .filter(Boolean)
            .join(", "),
        ),
      }));
      setIsGstVerified(true);
    }
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (type === "number" || name === "zipCode") {
      // Block 'e', 'E', '-', '+', and '.' for phone number input
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.gstin || formData.gstin.length < 15)
      newErrors.gstin = "Enter the valid GSTIN ";

    if (!formData.organizationSize)
      newErrors.organizationSize = "Organization Size is required";
    if (!formData.sector) newErrors.sector = "Industry Sector is required";
    if (!formData.name) newErrors.name = "Organization name is required";
    if (!formData.organizationAddress)
      newErrors.organizationAddress = "Address is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.zipCode || formData.zipCode.toString().length < 6)
      newErrors.zipCode = "Zip Code  is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  // handle save button
  const handleSave = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Proceed with form submission or further logic
      try {
        setIsLoading(true);
        // Extract the necessary fields from formData
        const {
          name,
          gstin,
          sector,
          organizationSize,
          organizationAddress,
          city,
          state,
          zipCode,
        } = formData;

        // Make the PUT request
        const response = await axios.put(
          `${serverURL}/organization/update/${localStorage.getItem(
            "organisationId",
          )}`,
          {
            organizationName: name,
            state,
            city,
            gstin: gstin,
            pinCode: zipCode,
            address: organizationAddress,
            sector: sector,
            organizationSize: organizationSize,
          },
        );
        if (response.data.success) {
          setSnackbar({
            open: true,
            message: "Organization updated successfully.",
            severity: "success",
          });
          setIsEditable(false); // Toggle edit state

          setIsLoading(false);
          getOrganizationDetails(localStorage.getItem("clientId"));
        } else {
          setSnackbar({
            open: true,
            message: "Error updating Organisation",
            severity: "error",
          });

          setIsLoading(false);
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Error updating Organisation.",
          severity: "error",
        });

        setIsLoading(false);
      }
    }
  };
  const handleEdit = () => {
    setIsEditable(true); // Toggle edit state
  };
  const handleDiscard = () => {
    setIsEditable(false); // Toggle edit state
    getOrganizationDetails(clientId);
    setErrors({});
  };

  const handleSnackbarClose = () => {
    setSnackbar({
      open: false,
    });
  };
  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileHeader}>
        <h2 className={styles.heading}>ORGANISATION</h2>
        {isEditable ? (
          <div className="flex justify-center items-center gap-2">
            <Button
              onClick={handleDiscard}
              variant="outlined"
              size="small"
              className="shadow-md shadow-red-500/40"
              startIcon={<DeleteOutlineIcon />}
              sx={{
                color: "error.main",
                borderColor: "error.light",
                "&:hover": {
                  backgroundColor: "error.lighter", // custom theme or fallback
                  boxShadow: 2,
                  borderColor: "error.main",
                },
                transition: "all 0.2s ease-in-out",
                textTransform: "none",
              }}
            >
              Discard
            </Button>
            {isEditable && (
              <Grid item xs={12} className="text-right">
                <CustomButton
                  text="Save"
                  color="var(--heading-color)"
                  fontWeight="600"
                  className="w-100 block"
                  onClick={handleSave}
                  isLoading={isLoading}
                />
              </Grid>
            )}
          </div>
        ) : (
          <div className={styles.editButton}>
            {userRole == 1 && (
              <Button
                className="shadow-md shadow-indigo-500/40"
                variant="outlined"
                size="small"
                style={{ border: 0 }}
                onClick={handleEdit}
              >
                <DriveFileRenameOutlineOutlinedIcon /> Edit
              </Button>
            )}
          </div>
        )}
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: "100%",
            }}
          >
            <CustomInput
              className="text-xs font-medium leading-6 text-left"
              placeholder="Enter Your GSTIN"
              title="GSTIN *"
              disabled={!isEditable}
              type="text"
              size="small"
              name="gstin"
              error={errors.gstin}
              errorMessage={errors.gstin}
              value={formData?.gstin}
              customcolor="var(--heading-color)"
              fontWeight="500"
              onChange={(e) => {
                if (
                  !e.target.value.startsWith(" ") &&
                  e.target.value.length < 16
                ) {
                  handleInputChange(e);
                }
              }}
            />

            {loading ? (
              <div
                style={{
                  position: "absolute",
                  top: "70%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress color="inherit" size={20} />
              </div>
            ) : errors.gstin ? (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Cross
                  color="var(--error-color)"
                  fillcolor="var(--error-color)"
                />
              </div>
            ) : isGstVerfied ? (
              <div
                style={{
                  position: "absolute",
                  top: "70%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  width: "20px",
                  height: "20px",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <VerifiedTick
                  color="var(--third-color)"
                  fillcolor="var(--third-color)"
                />
              </div>
            ) : null}
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          {/* <Grid item className="col-span-2 md:col-span-6"> */}
          <CustomInput
            className="text-xs font-medium leading-6 text-left"
            placeholder="Enter Your Organisation Name"
            title="Organisation Name *"
            disabled={!isEditable}
            type="text"
            size="small"
            // disabled
            name="name"
            error={errors.name}
            customcolor="var(--heading-color)"
            fontWeight="500"
            errorMessage={errors.name}
            value={formData?.name}
            onChange={(e) => {
              if (!e.target.value.startsWith(" ")) {
                handleInputChange(e);
              }
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <InputLabel
            style={{
              fontWeight: "400",
              color: errors.sector
                ? "var(--error-color)"
                : "var(--heading-color)",
            }}
          >
            Sector *
          </InputLabel>
          <FormControl
            fullWidth
            size="small"
            sx={{ marginTop: "0.5rem" }}
            disabled={!isEditable}
          >
            <Select
              inputProps={{
                "aria-label": "Without label",
              }}
              displayEmpty
              name="sector"
              value={formData?.sector}
              onChange={handleInputChange}
              renderValue={(selected) => {
                // This renders gray color when no option is selected
                if (!selected || selected.length === 0) {
                  return (
                    <p className="text-[1rem] text-[var(--listdown-color)]">
                      Industry Sector
                    </p>
                  );
                }
                // When an option is selected, show black
                return <span style={{ color: "#000" }}>{selected}</span>;
              }}
              sx={{
                color: formData?.userRole ? "#000" : "#B0B0B0", // Default gray, selected text turns black
              }}
            >
              <MenuItem value="FMCG">FMCG</MenuItem>
              <MenuItem value="Agricultural">Agricultural</MenuItem>
              <MenuItem value="Automotive">Automotive</MenuItem>
              <MenuItem value="Banking & Finance">Banking & Finance</MenuItem>
              <MenuItem value="Hospitality & Travel">
                Hospitality & Travel
              </MenuItem>
              <MenuItem value="Entertainment & Media">
                Entertainment & Media
              </MenuItem>
              <MenuItem value="Healthcare">Healthcare</MenuItem>
              <MenuItem value="Textile Industry">Textile Industry</MenuItem>
              <MenuItem value="Energy">Energy</MenuItem>
              <MenuItem value="Tele Communication">Tele Communication</MenuItem>
            </Select>
          </FormControl>
          {errors.sector && (
            <p className=" leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
              {errors.sector}
            </p>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <InputLabel
            style={{
              fontWeight: "400",
              color: errors.organizationSize
                ? "var(--error-color)"
                : "var(--heading-color)",
            }}
          >
            Organization Size *
          </InputLabel>
          <FormControl
            fullWidth
            size="small"
            sx={{ marginTop: "0.5rem" }}
            disabled={!isEditable}
          >
            <Select
              inputProps={{
                "aria-label": "Without label",
              }}
              displayEmpty
              name="organizationSize"
              value={formData?.organizationSize}
              onChange={handleInputChange}
              renderValue={(selected) => {
                // This renders gray color when no option is selected
                if (!selected || selected.length === 0) {
                  return (
                    <p className="text-[1rem] text-[var(--listdown-color)]">
                      Size of your Organisation
                    </p>
                  );
                }
                // When an option is selected, show black
                return <span style={{ color: "#000" }}>{selected}</span>;
              }}
              sx={{
                color: formData?.userRole ? "#000" : "#B0B0B0", // Default gray, selected text turns black
              }}
            >
              <MenuItem value="1-10">1-10</MenuItem>
              <MenuItem value="11-50">11-50</MenuItem>
              <MenuItem value="51-200">51-200</MenuItem>
              <MenuItem value="201-500">201-500</MenuItem>
              <MenuItem value="501-1000">501-1000</MenuItem>
              <MenuItem value="1001-5000">1001-5000</MenuItem>
              <MenuItem value="5000+">5000+</MenuItem>
            </Select>
          </FormControl>
          {errors.organizationSize && (
            <p className=" leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
              {errors.organizationSize}
            </p>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <InputLabel
            style={{
              fontWeight: "400",
              color: errors.state
                ? "var(--error-color)"
                : "var(--heading-color)",
            }}
          >
            State *
          </InputLabel>
          <FormControl
            fullWidth
            size="small"
            disabled={!isEditable}
            sx={{ marginTop: "0.5rem" }}
            error={errors.state}
            errorMessage={
              errors.state ? (
                <span style={{ color: "var(--error-color)" }}>
                  Please Enter State
                </span>
              ) : null
            }
            value={formData?.state.name || formData?.state}
          >
            <Select
              inputProps={{
                "aria-label": "Without label",
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Set border color
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Keep border color on focus
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Keep border color on hover
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#b0b0b0", // Ensure hover state is consistent
                  },
                },
              }}
              style={{ color: formData?.state ? "" : "#a2a2a2" }}
              displayEmpty
              name="state"
              // onBlur={(e) => {
              //   emptyInputCheck(e.target.name, e.target.value);
              //   if (saveButtonClicked) {
              //     validateForm();
              //   }
              // }}
              value={formData?.state.name || formData?.state}
              onChange={handleInputChange}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <p className="text-[1rem] text-[var(--light-gray)]">
                      State
                    </p>
                  );
                }

                return selected;
              }}
            >
              {statecityData.map((state) => (
                <MenuItem key={state.name} value={state.name}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {errors.state && (
            <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
              {errors.state}
            </p>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <InputLabel
            style={{
              fontWeight: "400",
              color: errors.city
                ? "var(--error-color)"
                : "var(--heading-color)",
            }}
          >
            {" "}
            City *
          </InputLabel>

          <FormControl
            fullWidth
            disabled={!isEditable}
            size="small"
            sx={{ marginTop: "0.5rem" }}
            error={errors.city}
          >
            <Select
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Set border color
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Keep border color on focus
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#b0b0b0", // Keep border color on hover
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#b0b0b0", // Ensure hover state is consistent
                  },
                },
              }}
              style={{ color: formData?.city ? "" : "#a2a2a2" }}
              inputProps={{
                "aria-label": "Without label",
              }}
              displayEmpty
              name="city"
              //-------------------------------------------------------
              value={formData?.city || ""}
              onChange={handleInputChange}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return (
                    <p className="text-[1rem]  text-[var(--light-gray)]">
                      City
                    </p>
                  );
                }
                return selected;
              }}
            >
              {cityArray.map((city) => (
                <MenuItem key={city.name} value={city.name}>
                  {city.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {errors.city && (
            <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
              {errors.city}
            </p>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          <CustomInput
            className="text-xs font-medium leading-6 text-left"
            placeholder="Enter Your Pincode"
            title="ZIP/Postcode *"
            type="number"
            disabled={!isEditable}
            size="small"
            name="zipCode"
            error={errors.zipCode}
            errorMessage={errors.zipCode}
            customcolor="var(--heading-color)"
            fontWeight="500"
            helperTextColor="var(--error-color)"
            value={formData?.zipCode}
            // disabled
            onKeyPress={(e) => handleKeyPress(e)}
            onChange={(e) => {
              if (
                !e.target.value.startsWith(" ") &&
                e.target.value.length <= 6
              ) {
                handleInputChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomInput
            className="text-xs font-medium leading-6 text-left"
            placeholder="Enter Your Organisation Address"
            title="Address *"
            disabled={!isEditable}
            type="text"
            size="small"
            name="organizationAddress"
            error={errors.organizationAddress}
            errorMessage={errors.organizationAddress}
            value={formData?.organizationAddress}
            customcolor="var(--heading-color)"
            fontWeight="500"
            // disabled
            onChange={(e) => {
              if (!e.target.value.startsWith(" ")) {
                handleInputChange(e);
              }
            }}
          />
        </Grid>
      </Grid>

      <GlobalSnackbar snackbar={snackbar} handleClose={handleSnackbarClose} />
    </div>
  );
};

export default Organisation;
